/*
 * Copyright (c) 2022 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import React from 'react';
import ColdStartLarge from '../Card/ColdStartLarge';
import { RailBackgroundImageName } from '../../../types/components/ColdStart';
import RailSlider from './RailSlider';

interface Props {
  railId: string | number;
  railName: string;
  railBackgroundImageName: RailBackgroundImageName;
  railDescription: string;
  className?: string;
  coldStartTitle?: string;
  requiresPrivacyConsent?: boolean;
  onClickPrivacyConcentOptIn?: () => void;
}

export default function ColdStartRail({
  railId,
  railName,
  railBackgroundImageName,
  railDescription,
  className,
  coldStartTitle,
  requiresPrivacyConsent,
  onClickPrivacyConcentOptIn,
}: Props): JSX.Element {
  return (
    <div className={`rail ${className} cold-start`}>
      <div className="rail-row" id={`ColdStartRail___${railId}`}>
        <header className="rail-header">
          <h2>
            <a className="disabled-href" id={`ColdStartRail_name___${railId}`}>
              {railName}
            </a>
          </h2>
        </header>
        <RailSlider
          cards={[
            <ColdStartLarge
              key={railId}
              bemModifier={railId}
              railBackgroundImageName={railBackgroundImageName}
              coldStartText={railDescription}
              coldStartTitle={coldStartTitle}
              requiresPrivacyConsent={requiresPrivacyConsent}
              onClickPrivacyConcentOptIn={onClickPrivacyConcentOptIn}
            />,
          ]}
        />
      </div>
    </div>
  );
}
